import styled from "styled-components";

export const EditDeleteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
`;

export const EditDeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  color: #482959;

  font-weight: 600;
  padding: 4px 16px;
  gap: 8px;
  width: 55px;
  height: 23px;
  background: #fbf8fc;
  border-radius: 4px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 15px;
  transition: all 0.3s ease-in-out;
  &:hover {
    color: #000;
    transform: scale(1.1);
  }
  &:disabled {
    color: gray;
    cursor: not-allowed;
  }
`;
